import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AuthClientConfig } from '@auth0/auth0-angular';
import { MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG, MsalGuardConfiguration, MsalInterceptorConfiguration } from '@azure/msal-angular';
import { InteractionType, PublicClientApplication } from '@azure/msal-browser';
import '@google/model-viewer';
import { OKTA_CONFIG } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';
import { AuthConfig } from 'angular-oauth2-oidc';
import { AppModule } from './app/app.module';
import { AuthType } from './app/core/models/globals';
import { PING_IDENTITY_CONFIG } from './app/core/models/ping-auth-config.token';
import { APP_CONFIG } from './app/core/services/auth-config.service';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
  if(window) {
    window.console.log = function() {};
  }
}

fetch('').then(async res => {
  let baseUrl = `${window.location.origin}/api/UserInfoes/GetAuthenticationType`;
  let headers = new HttpHeaders();
  headers = headers.set('Content-Type', 'application/json; charset=utf-8')
    .set('Cache-Control', 'no-cache')
  let authType;
  let authParams;
  const authConfig = await fetch(baseUrl).then(async res => { return res.json() }).catch(err => {
    authType = 0;
    authParams = null;
  });

  if (authConfig) {
    authType = authConfig['authType'];
    authParams = authConfig['authParams'];
    if ((authType == AuthType.AzureAD || authType == AuthType.Okta) && !authParams) {
      
    }
    localStorage.setItem("authenticationType", JSON.stringify(authType));
  }

  let config = {
    domain: '',
    clientId: '',
    authorizationParams: {
      redirect_uri: window.location.origin,
      audience: ''
    }
  }

  if(authType == AuthType.OpenId) {
    config.domain = authParams?.domain;
    config.clientId = authParams?.clientId;
    config.authorizationParams.audience = authParams?.audience;
  }

  let pingIdentity: AuthConfig = {
    "clientId": "",
    "issuer": "",
    "redirectUri": "",
    "scope": "openid profile email",
    "responseType": "code",
    "showDebugInformation": true,
    "disablePKCE": true
  }  

  let oktaAuth = new OktaAuth({ issuer: "https://xxx.okta.com", clientId: "xxx", redirectUri: "", scopes: [] })
  let azureAuth = new PublicClientApplication({
    auth: {
      clientId: "",
      authority: "",
      redirectUri: "",
      postLogoutRedirectUri: ""
    },
    cache: {
      cacheLocation: "",
      storeAuthStateInCookie: false
    }
  });
  let msalGuardConfig = {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: ['user.read', 'openid', 'profile']
    }
  } as MsalGuardConfiguration;
  let msalInterceptorConfig = {
    interactionType: InteractionType.Redirect,
    protectedResourceMap: new Map([
      ["", ['validation']]
    ])
  } as MsalInterceptorConfiguration;

  switch (authType) {
    case AuthType.AzureAD:
      platformBrowserDynamic([
        { provide: OKTA_CONFIG, useValue: { oktaAuth: oktaAuth } },
        {
          provide: MSAL_INSTANCE, useValue: new PublicClientApplication({
            auth: {
              clientId: authParams?.clientID,
              authority: authParams?.authority + authParams?.azureADTenantID,
              redirectUri: authParams?.redirectUri,
              postLogoutRedirectUri: authParams?.postLogoutRedirectUri
            },
            cache: {
              cacheLocation: authParams?.cacheLocation,
              storeAuthStateInCookie: authParams?.storeAuthStateInCookie
            }
          })
        },
        {
          provide: MSAL_GUARD_CONFIG, useValue: msalGuardConfig
        },
        {
          provide: MSAL_INTERCEPTOR_CONFIG, useValue: msalInterceptorConfig
        },
        { provide: APP_CONFIG, useValue: config },
        { provide: PING_IDENTITY_CONFIG, useValue: pingIdentity },
      ]).bootstrapModule(AppModule)
        .catch(err => console.error(err));
      break;

    case AuthType.Okta:
      platformBrowserDynamic([
        { provide: OKTA_CONFIG, useValue: { oktaAuth: new OktaAuth(authParams) } },
        {
          provide: MSAL_INSTANCE, useValue: azureAuth
        },
        {
          provide: MSAL_GUARD_CONFIG, useValue: msalGuardConfig
        },
        {
          provide: MSAL_INTERCEPTOR_CONFIG, useValue: msalInterceptorConfig
        },
        { provide: APP_CONFIG, useValue: config },
        { provide: PING_IDENTITY_CONFIG, useValue: pingIdentity },
      ]).bootstrapModule(AppModule)
        .catch(err => console.error(err));
      break;

    case AuthType.PingIdentity:
      pingIdentity = {
        "clientId": authParams?.publicClientId,        
        "issuer": authParams?.issuer,
        "tokenEndpoint": authParams?.tokenEndpoint,
        "redirectUri": authParams?.redirectUri,
        "scope": authParams?.scope,
        "responseType": authParams?.responseType,
        "showDebugInformation": authParams?.showDebugInformation,
        "disablePKCE": authParams?.disablePKCE,
      };
      platformBrowserDynamic([
        { provide: OKTA_CONFIG, useValue: { oktaAuth: oktaAuth } },
        {
          provide: MSAL_INSTANCE, useValue: azureAuth
        },
        {
          provide: MSAL_GUARD_CONFIG, useValue: msalGuardConfig
        },
        {
          provide: MSAL_INTERCEPTOR_CONFIG, useValue: msalInterceptorConfig
        },
        { provide: APP_CONFIG, useValue: config },
        { provide: PING_IDENTITY_CONFIG, useValue: pingIdentity },
      ]).bootstrapModule(AppModule)
        .catch(err => console.error(err));
      break;

    case AuthType.SyncHPCAPI:
    case AuthType.LDAP:
    default:
      platformBrowserDynamic([
        { provide: OKTA_CONFIG, useValue: { oktaAuth: oktaAuth } },
        {
          provide: MSAL_INSTANCE, useValue: azureAuth
        },
        {
          provide: MSAL_GUARD_CONFIG, useValue: msalGuardConfig
        },
        {
          provide: MSAL_INTERCEPTOR_CONFIG, useValue: msalInterceptorConfig
        },
        { provide: APP_CONFIG, useValue: config },
        { provide: PING_IDENTITY_CONFIG, useValue: pingIdentity },
      ]).bootstrapModule(AppModule)
        .catch(err => console.error(err));
      break;
  }
});


function openIdFn(handler: HttpBackend,config: AuthClientConfig) {
  return () => {
    return new HttpClient(handler).get('assets/config/openid.json').toPromise().then((loadedConfig: any) => {
      config.set(loadedConfig);
    });
  };
}
